import { FormEvent, useState } from 'react'

export interface PromptSpec {
  title: string
  /** Shown above the field when the title alone doesn't explain enough. */
  body?: string
  label: string
  initial?: string
  placeholder?: string
  confirmLabel?: string
  /**
   * Whether an empty answer is a real answer. Usually it is not, a category
   * with no name is nothing. But "no tick-box notes for this category" is a
   * decision someone makes deliberately, and clearing the field is how they
   * say it.
   */
  allowEmpty?: boolean
  onConfirm: (value: string) => void
}

interface Props extends PromptSpec {
  onClose: () => void
}

/**
 * Asks for one line of text, replacing window.prompt.
 *
 * The browser's version cannot be styled, cannot say what the field is for
 * beyond a single line, and on some phones cannot be dismissed by tapping
 * away. It also arrives with an OK button in the browser's language, next to a
 * question written in Turkish.
 */
export function PromptDialog({
  title,
  body,
  label,
  initial = '',
  placeholder,
  confirmLabel = 'Kaydet',
  allowEmpty,
  onConfirm,
  onClose,
}: Props) {
  const [value, setValue] = useState(initial)
  const trimmed = value.trim()

  const submit = (e: FormEvent) => {
    e.preventDefault()
    if (!trimmed && !allowEmpty) return
    onClose()
    onConfirm(trimmed)
  }

  return (
    <div className="dlg" role="dialog" aria-modal="true">
      <form className="dlg__card dlg__card--ask" onSubmit={submit}>
        <h2>{title}</h2>
        {body && <p className="dlg__empty">{body}</p>}

        <label className="dlgfield">
          <span>{label}</span>
          <input
            value={value}
            onChange={(e) => setValue(e.target.value)}
            placeholder={placeholder}
            // Açılınca doğrudan yazılsın, Enter onaylasın (21 Eki 2026).
            autoFocus
          />
        </label>

        <div className="dlg__buttons dlg__buttons--even">
          <button type="button" className="btn btn--ghost" onClick={onClose}>
            Vazgeç
          </button>
          <button type="submit" className="btn btn--primary" disabled={!trimmed && !allowEmpty}>
            {confirmLabel}
          </button>
        </div>
      </form>
    </div>
  )
}
